var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sj-button',{staticStyle:{"margin":"10px"},on:{"click":_vm.click1}},[_vm._v("download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }